@import '../../global/utility/skinning/invert-colors';

$remaining-page-space-x: calc(var(--component-container-remaining-space, 9.7%) / 2);

ui-cms-container {
  display: block;
  border: 0;

  // spacing between components in the container
  > *:not(ui-cms-anchor) {
    margin-bottom: $sd-spacing-8;
  }

  > *:last-child {
    margin-bottom: 0;
  }

  // spacing between components in the brandshape
  .brandshape-content-wrapper {
    > *:not(ui-cms-anchor) {
      margin-bottom: $sd-spacing-8;
    }

    > *:last-child {
      margin-bottom: 0;
    }
  }

  &.no-padding {
    padding: 0;
  }

  &.full-width {
    margin-left: calc(-1 * $remaining-page-space-x);
    margin-right: calc(-1 * $remaining-page-space-x);
    padding: 17px $remaining-page-space-x;

    &.no-padding {
      padding: 0;
    }

    @include breakpoint($small) {
      padding: 17px $remaining-page-space-x;
    }

    @include breakpoint($medium) {
      padding: 37px $remaining-page-space-x;
    }

    @include breakpoint($xxlarge) {
      margin-left: calc(var(--component-container-remaining-space, calc(100vw - 1200px)) / -2);
      margin-right: calc(var(--component-container-remaining-space, calc(100vw - 1200px)) / -2);
      padding: 37px calc(var(--component-container-remaining-space, calc(100vw - 1200px)) / 2);
    }
  }

  // Inverted logic for component library compatibility
  // can be removed once all components are updated
  &.sd-container {
    @include resetCurrentColors();

    /* The overflow: visible is applied to ensure that the triangle arrows used in the "text with infobox"
    component are displayed correctly outside the container. This is specifically needed when
    the variant is set to border-neutral-400 and one of the following classes is applied:
    sd-container--triangle-right-border, sd-container--triangle-left-border, or sd-container--triangle-top-border.
    Without this, the parent container's overflow: hidden would clip the arrows. By setting overflow: visible
    for these specific cases, we ensure the arrows are shown properly while maintaining the overall layout. */
    &--triangle-right-border,
    &--triangle-top-border,
    &--triangle-bottom-border,
    &--triangle-left-border {
      overflow: visible;
    }
  }

  &.sd-container.sd-container--variant-primary {
    color: var(--component-container-primary-color, var(--skin-color-text-inverted, #{$ui-white}));
    @include invertCurrentColors();
  }

  &.brandshape {
    @include resetCurrentColors();
  }

  &.brandshape.brandshape--variant-primary {
    color: var(--component-container-primary-color, var(--skin-color-text-inverted, #{$ui-white}));
    @include invertCurrentColors();
  }
}
